import React from "react";
import { Link, useLocation } from "react-router-dom";
import { UserButton } from "@clerk/clerk-react";
import { useAuth } from "../../contexts/ClerkAuthContext";

interface NavbarProps {
  applicationName?: string;
}

export const Navbar: React.FC<NavbarProps> = ({ applicationName }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const renderAuthLinks = () => {
    if (isAuthenticated) {
      return (
        <div className="flex items-center space-x-4">
          {/* Gear icon hidden - OAuth not supported at this time
          <Link
            to="/settings"
            className="p-2 text-gray-700 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            title="Integrations"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </Link>
          */}
          <UserButton
            appearance={{
              elements: {
                avatarBox: 'w-6 h-6',
                userButtonPopoverCard: 'shadow-lg',
              }
            }}
          />
        </div>
      );
    }

    // Show Sign Up link on signin page, and Sign In link on signup page
    if (location.pathname === "/signin") {
      return (
        <Link
          to="/signup"
          className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Sign up
        </Link>
      );
    }

    // Must be on signup page
    return (
      <Link
        to="/signin"
        className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        Sign in
      </Link>
    );
  };

  return (
    <nav className="bg-white shadow border-b border-gray-200">
      <div className="px-6">
        <div className="flex justify-between h-10">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/" className="text-sm font-bold text-indigo-600">
                Vibe
              </Link>
            </div>
          </div>
          {applicationName && (
            <div className="flex items-center">
              <span className="text-sm font-mono text-gray-700" style={{ letterSpacing: '0.05em' }}>
                {applicationName}
              </span>
            </div>
          )}
          <div className="flex items-center">{renderAuthLinks()}</div>
        </div>
      </div>
    </nav>
  );
};
